





































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { RequestTaskImageModel } from "@/api/Requests/models/RequestTaskImageModel";
import { Observer } from "mobx-vue";

@Observer
@Component
export default class ButtonImageCarousel extends Vue {
  @Prop({ required: true }) readonly displayImages: RequestTaskImageModel[] | undefined;
  dispose?: () => void;

  images: RequestTaskImageModel[] = [];
  showCarousel = false;
  currentSlide = 0;

  @Watch("showCarousel")
  fetchData() {
    if (this.showCarousel) {
      this.images = this.displayImages || [];
    } else {
      this.images = [];
    }
  }

  openCarousel() {
    this.showCarousel = true;
  }

  closeCarousel() {
    this.showCarousel = false;
  }
}
